var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3615 21.3631C21.7276 20.997 21.7276 20.4034 21.3615 20.0373L8.98713 7.66291C8.62102 7.2968 8.02742 7.2968 7.66131 7.66291C7.29519 8.02903 7.29519 8.62262 7.66131 8.98874L20.0357 21.3631C20.4018 21.7292 20.9954 21.7292 21.3615 21.3631Z",
    fill: "#0EC99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3631 7.66291C20.997 7.29681 20.4034 7.29681 20.0373 7.66291L7.66291 20.0373C7.2968 20.4034 7.29681 20.997 7.66291 21.3631C8.02902 21.7292 8.62262 21.7292 8.98874 21.3631L21.3631 8.98874C21.7292 8.62263 21.7292 8.02902 21.3631 7.66291Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.eb45ecb99e1cdb95433b0709563e2554.svg";
export { ForwardRef as ReactComponent };